const AGE_CHECK_STORAGE_KEY = 'image2video-web-ui:age-check:v1';

export function hasAcceptedAgeCheck(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    return window.localStorage.getItem(AGE_CHECK_STORAGE_KEY) === 'accepted';
  } catch {
    return false;
  }
}

export function acceptAgeCheck(): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(AGE_CHECK_STORAGE_KEY, 'accepted');
  } catch {
    // noop
  }
}
